<template>
  <div
    class="min-h-screen bg-gray-50 dark:bg-gray-900 z-10 w-full flex flex-col items-center justify-center p-4 text-center"
  >
    <div
      class="max-w-md w-full bg-white dark:bg-gray-800 rounded-xl shadow-lg dark:shadow-gray-700/50 p-8 space-y-6"
    >
      <div class="flex justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-24 w-24 text-main-800 dark:text-sub-300"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>

      <h1 class="text-5xl font-bold text-gray-800 dark:text-gray-100">404</h1>
      <h2 class="text-2xl font-semibold text-gray-700 dark:text-gray-200">
        Page Not Found
      </h2>

      <p class="text-gray-600 dark:text-gray-300">
        Oops! The page you're looking for doesn't exist or has been moved.
      </p>

      <router-link
        to="/"
        class="inline-block px-6 py-3 bg-main-800 hover:bg-main-900 dark:bg-sub-600 dark:hover:bg-sub-700 text-white font-medium rounded-lg transition duration-200"
      >
        Return Home
      </router-link>

      <div class="pt-4 text-sm text-gray-500 dark:text-gray-400">
        <p>Or try searching for what you need</p>
      </div>
    </div>
  </div>
</template>
